import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import reportWebVitals from "./reportWebVitals";

import App from "./pages/App";
import AuthContextProvider from "./context/AuthContext";
import ModalContextProvider from "./context/ModalContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ModalContextProvider>
    <AuthContextProvider>
      <App />
    </AuthContextProvider>
  </ModalContextProvider>
);

reportWebVitals();
